import { ActivityNote } from "0.Mine/0.Components/CRM/Leads/sharedTypes";
import { FormData } from "0.Mine/0.Components/CRM/Leads/sharedTypes";
import { CRMtodoCard, KanbanCard, KanbanRequest } from "0.Mine/3.Interfaces/todoCard";

import { AdditionalParams, QlickupActions, useQlickupAPI } from "../APICall";

interface KanbanCardResponse {
  id: number;
  lead_id: number;
  business_id: number;
  title: string;
  description: string;
  status: string;
  lead: {
    id: number;
    businessid: number;
    name: string;
    status: string;
    [key: string]: any;
  };
  [key: string]: any;
}

export const UseHandleKanban = () => {
  const { QlickUpAPI } = useQlickupAPI();

  const getOneKanbanCard = async (businessId: number, kanbanCard: number) => {
    try {
      const response = await QlickUpAPI(
        businessId.toString(),
        "getone",
        null,
        "kanban",
        QlickupActions.GET,
        { cardid: kanbanCard }
      );

      console.log(response);

      return response as KanbanCardResponse;
    } catch (error) {
      console.error("Error retrieving kanban card:", error);
    }
  };

  const getKanban = async (businessId: number) => {
    try {
      const response = await QlickUpAPI(
        businessId.toString(),
        "getkanban",
        null,
        "kanban",
        QlickupActions.GET
      );

      console.log(response);

      return response as KanbanRequest;
    } catch (error) {
      console.error("Error retrieving kanban card:", error);
    }
  };

  const getAllKanbanCards = async (businessId: number) => {
    try {
      const response = await QlickUpAPI(
        businessId.toString(),
        "getall",
        null,
        "kanban",
        QlickupActions.GET
      );

      return response.kanban as KanbanCard[];
    } catch (error) {
      console.error("Error retrieving kanban cards:", error);
      return null;
    }
  };

  const createKanbanCard = async (businessId: number, card: CRMtodoCard) => {
    try {
      const response = await QlickUpAPI(
        businessId.toString(),
        "createcard",
        card,
        "kanban",
        QlickupActions.POST
      );

      console.log(response);

      return response.cardId as string;
    } catch (error) {
      console.error("Error creating kanban card:", error);
      return null;
    }
  };

  const createKanbanBoard = async (businessId: number, board: string) => {
    const additionalParams: AdditionalParams = {
      name: board,
    };
    try {
      const response = await QlickUpAPI(
        businessId.toString(),
        "createColumn",
        null,
        "kanban",
        QlickupActions.POST,
        additionalParams
      );

      console.log(response);

      return response.column.id as string;
    } catch (error) {
      console.error("Error creating kanban card:", error);
      return null;
    }
  };

  const reorderKanban = async (businessId: number, columnOrderData: Record<string, number>) => {
    try {
      const response = await QlickUpAPI(
        businessId.toString(),
        "updateColumnOrder",
        columnOrderData,
        "kanban",
        QlickupActions.POST
      );

      console.log("Reorder response:", response);
    } catch (error) {
      console.error("Error reordering kanban columns:", error);
      return null;
    }
  };

  const deleteKanban = async (businessId: number, columnId: number) => {
    try {
      const response = await QlickUpAPI(
        businessId.toString(),
        "deleteColumn",
        null,
        "kanban",
        QlickupActions.POST,
        { columnid: columnId }
      );

      if (!response || response.error) {
        console.error("Error in delete response:", response?.error || "No response");
        throw new Error(response?.error || "Failed to delete column");
      }

      return true;
    } catch (error) {
      console.error("Error deleting kanban column:", error);
      throw error;
    }
  };

  const SaveKanbanChanges = async (businessId: number, board: any) => {
    const changes = board;

    try {
      if (!changes) {
        console.error("No changes to save.");
        return;
      }
      const deleted = changes.deleted;
      const moved = changes.moved;

      if (deleted) {
        const response = await QlickUpAPI(
          businessId.toString(),
          "delete",
          deleted,
          "kanban",
          QlickupActions.POST
        );

        console.log(response);
      }
      if (moved) {
        const response = await QlickUpAPI(
          businessId.toString(),
          "move",
          moved,
          "kanban",
          QlickupActions.POST
        );

        console.log(response);
      }
    } catch (error) {
      console.error("Error saving kanban changes:", error);
    }
  };

  const CreateDefaultKanban = async (businessId) => {
    try {
      const response = await QlickUpAPI(
        businessId.toString(),
        "createBoard",
        null,
        "kanban",
        QlickupActions.POST
      );

      console.log(response);
    } catch (error) {
      console.error("Error creating default kanban board:", error);
    }
  };

  const renameKanbanBoard = async (businessId: number, boardId: number, newName: string) => {
    try {
      const additionalParams: AdditionalParams = {
        columnId: boardId,
        newname: newName,
      };
      const response = await QlickUpAPI(
        businessId.toString(),
        "renameColumn",
        null,
        "kanban",
        QlickupActions.POST,
        additionalParams
      );

      console.log(response);
    } catch (error) {
      console.error("Error renaming kanban board:", error);
    }
  };

  const moveKanbanCard = async (businessId: number, cardId: number, from: string, to: string) => {
    try {
      const additionalParams: AdditionalParams = {
        cardId: cardId,
        from: from,
        to: to,
      };
      const response = await QlickUpAPI(
        businessId.toString(),
        "moveCard",
        null,
        "kanban",
        QlickupActions.POST,
        additionalParams
      );

      console.log(response);
    } catch (error) {
      console.error("Error moving kanban card:", error);
    }
  };

  const createActivityNote = async (
    businessId: number,
    cardId: number,
    activityNote: ActivityNote
  ) => {
    try {
      const response = await QlickUpAPI(
        businessId.toString(),
        "createActivityNote",
        activityNote,
        "kanban",
        QlickupActions.POST,
        { cardId: cardId }
      );

      console.log(response);

      return response.noteId as string;
    } catch (error) {
      console.error("Error creating activity note:", error);
      return null;
    }
  };

  const getAllCardActivityNotes = async (businessId: number, cardId: number) => {
    try {
      const response = await QlickUpAPI(
        businessId.toString(),
        "getAllCardActivityNotes",
        null,
        "kanban",
        QlickupActions.GET,
        { cardId: cardId }
      );

      console.log(response);

      if (!response.activities) {
        console.error("No notes found for this card.");
        return null;
      }
      return response.activities as ActivityNote[];
    } catch (error) {
      console.error("Error retrieving activity notes:", error);
      return null;
    }
  };

  const getCardActivityAsFormData = async (businessId: number, cardId: number) => {
    try {
      const response = await QlickUpAPI(
        businessId.toString(),
        "getSingleActivity",
        null,
        "kanban",
        QlickupActions.GET,
        { cardId: cardId }
      );

      console.log(response);

      const card = response.card;
      const lead = response.lead;

      const formData: FormData = {
        name: lead.name,
        company: lead.company,
        email: lead.email,
        phone: lead.phone,
        lastContact: new Date(lead.lastContact),
        value: lead.value,
        notes: lead.notes,
        state: card.state,
        leadSource: card.leadSource,
        dueDate: new Date(card.dueDate) || new Date(lead.dueDate),
        statusId: lead?.status?.id || "",
        probability: lead?.probability || 0,
        vendorId: lead?.vendorId || "",
        vendorName: lead?.vendorName || "",
        address: lead?.address || "",
        city: lead?.city || "",
      };
      return formData;
    } catch (error) {
      console.error("Error retrieving activity notes:", error);
      return null;
    }
  };

  const assignCardToVendor = async (businessId: number, cardId: number, vendorId: number) => {
    try {
      const response = await QlickUpAPI(
        businessId.toString(),
        "assigntovendor",
        null,
        "kanban",
        QlickupActions.POST,
        { cardId: cardId, vendorId: vendorId }
      );

      console.log(response);
    } catch (error) {
      console.error("Error assigning card to vendor:", error);
    }
  };

  return {
    getAllKanbanCards,
    createKanbanCard,
    SaveKanbanChanges,
    getOneKanbanCard,
    createKanbanBoard,
    getKanban,
    reorderKanban,
    deleteKanban,
    CreateDefaultKanban,
    renameKanbanBoard,
    moveKanbanCard,
    createActivityNote,
    getAllCardActivityNotes,
    getCardActivityAsFormData,
    assignCardToVendor,
  };
};
